import { render, staticRenderFns } from "./NominationListComponent.vue?vue&type=template&id=cc2d7832&scoped=true"
import script from "./NominationListComponent.vue?vue&type=script&lang=js"
export * from "./NominationListComponent.vue?vue&type=script&lang=js"
import style0 from "./NominationListComponent.vue?vue&type=style&index=0&id=cc2d7832&prod&lang=css"
import style1 from "./NominationListComponent.vue?vue&type=style&index=1&id=cc2d7832&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2d7832",
  null
  
)

export default component.exports